import { Link } from 'react-router-dom';
import { imageUrl } from '../../Constants/contant';

function ServiceCard(props) {

    const { serviceID, serviceImage, serviceTitle, serviceItem } = props;

    return (
            <div className="destination-item th-ani">
                <Link to={`/service-details/${serviceID}`}>
                <div className="destination-item_img global-img">
                    <img src={`${imageUrl}${serviceImage}`} alt="" />
                </div>
                    </Link>

                <div className="destination-content">
                    <h3 className="box-title">
                         {serviceTitle ? serviceTitle : 'Photo Shoot'}
                    </h3>
                     <Link to={`/service-details/${serviceID}`}>
                    <p className="destination-text">₹{serviceItem ? serviceItem : '20 Listing'}</p>
                    </Link>
                    
                <Link to={`/service-details/${serviceID}`} className="th-btn style4"> 
                View</Link>
                </div>
            </div>
    )
}

export default ServiceCard
